export default __webpack_public_path__ + "static/media/red onion.116886c4.png";